import { RewindVideo } from './rewindStitcher.types';

export const orderRewindsByTime = (rewinds: RewindVideo[]) =>
  rewinds.sort((a, b) => a.startDateTime.getTime() - b.startDateTime.getTime());

export default orderRewindsByTime;
